<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12">
        <v-row>
          <v-col cols="12" md="4">
            <h3>Themes</h3>
            <p class="mb-0 grey--text" style="font-size: 14px">Choose theme for your store</p>
          </v-col>
          <v-col cols="12" md="8" class="elevation-form">
            <ul class="list-theme">
              <li
                v-for="(item, index) in themes"
                :key="index"
                :class="{ actived: form.useSimpleCheckout === item.value }"
                @click="form.useSimpleCheckout = item.value"
              >
                <div class="image-wrapper mb-3">
                  <img :src="item.image" :alt="item.value" />
                </div>
                <v-dialog>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      :color="form.useSimpleCheckout === item.value ? 'primary' : ''"
                      block
                      depressed
                      >{{ item.name }}
                    </v-btn>
                  </template>

                  <v-card>
                    <div class="px-3 image-preview">
                      <img :src="item.image" :alt="item.value" />
                    </div>
                  </v-card>
                </v-dialog>
              </li>
            </ul>
          </v-col>
          <!-- <v-col cols="12" md="8" class="elevation-form">
            <v-checkbox
              v-model="form.useSimpleCheckout"
              label="Use Simple Checkout"
              class="option-checkbox-height"
            ></v-checkbox>
            <v-select
              v-model="form.useSimpleCheckout"
              :items="checkOutStyles.filter(item => item.type === getBusinessType())"
              item-text="name"
              item-value="value"
            ></v-select>
          </v-col> -->
        </v-row>
      </v-col>
      <v-col cols="12" class="mt-5 text-end">
        <v-btn :loading="isLoading" :disabled="isDisable3 || isDisable2 || isDisable1" @click="submit" color="primary"
          >Save
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { settingsApi } from '@/apis/settings';
import { ALL_THEMES, getThemeByValue } from '../../../../../const/themes';

export default {
  components: {
    // Style,
    // Footer,
    // CustomerAccount,
    // FormOptions,
    // EmailMarketing,
    // AbadonedCheckout,
    // AbadonedCheckoutSetting,
    // Tip,
  },
  data() {
    let defaultForm = {
      checkoutStepLayout: '3',
      checkoutFooter: '',
      isShowShippingOptions: false,
      form: {
        requireFirstName: true,
        requireCompanyName: 'string',
        requireAddressTwo: 'string',
        requireShippingPhone: 'string',
        requireAccount: 'string',
      },
      orderProcessing: {
        allowBillingAddrUsingShippingAddr: true,
        automaticFulfillLineItem: true,
        notifyShipment: true,
        automaticFulfillEvenHighRiskFraud: true,
        automaticArchiveOrder: true,
      },
      emailMarketing: {
        showSignUpOption: true,
        preselectSignUpOption: true,
      },
      abandonedCheckout: {
        useAdvancedEmailFlow: true,
        automaticSentAbandonedEmail: true,
        // onlySentToSubscribers: true,
        // sentAfter: 0,
        firstEmailScheduleTime: {
          sentAutomatically: true,
          sentAfter: 10,
          sentAfterText: 'm',
        },
        secondEmailScheduleTime: {
          sentAutomatically: true,
          sentAfter: 1,
          sentAfterText: 'h',
        },
        thirdEmailScheduleTime: {
          sentAutomatically: true,
          sentAfter: 1,
          sentAfterText: 'd',
        },
        automaticSentAbandonedSms: false,
        sentSmsToEveryone: true,
        firstSmsScheduleTime: {
          sentAutomatically: true,
          sentAfter: 10,
          sentAfterText: 'm',
        },
        secondSmsScheduleTime: {
          sentAutomatically: true,
          sentAfter: 1,
          sentAfterText: 'h',
        },
        thirdSmsScheduleTime: {
          sentAutomatically: true,
          sentAfter: 1,
          sentAfterText: 'd',
        },
      },
      orderEmail: {
        processDelay: {
          automaticSendOrderDelayEmail: true,
          sentAfter: 0,
        },
        shippingDelay: {
          automaticSendShippingDelayEmail: true,
          sentAfter: 0,
        },
      },
      checkoutLayout: 'string',
      footer: {
        showFooter: true,
      },
      tip: {
        isShow: false,
        name: 'Show your support for the team at {{shop.name}}',
        message: 'Thank you, we appreciate it.',
        options: [
          {
            id: 1,
            value: 5,
          },
          {
            id: 2,
            value: 10,
          },
          {
            id: 3,
            value: 15,
          },
        ],
      },
      useSimpleCheckout: 104,
      textMessage1: '',
      textMessage2: '',
      textMessage3: '',
    };
    return {
      isLoading: false,
      form: Object.assign({}, defaultForm),
      defaultForm,
      isDisable3: false,
      isDisable2: false,
      isDisable1: false,
      checkOutStyles: ALL_THEMES,
    };
  },
  computed: {
    themes() {
      return this.checkOutStyles.filter(item => item.type === this.getBusinessType());
    },
  },
  created() {
    this.getData();
  },
  methods: {
    async submit() {
      try {
        this.isLoading = true;
        await settingsApi.updateCheckout({
          ...this.form,
          theme: getThemeByValue(this.form.useSimpleCheckout),
        });
      } catch (error) {
        console.log('🚀 ~ submit ~ error:', error);
      } finally {
        this.isLoading = false;
      }
    },
    getBusinessType() {
      let businessType = 'dropship';
      if (localStorage.getItem(`FETCH_PAGE_PREFERRENCE`)) {
        businessType = JSON.parse(localStorage.getItem(`FETCH_PAGE_PREFERRENCE`)).businessType;
      }
      return businessType;
    },
    async getData() {
      try {
        this.isLoading = true;
        let res = await settingsApi.getCheckout();
        if (typeof res.data === 'object') {
          this.form = Object.assign({}, res.data);
          if (!this.form.tip) this.form.tip = this.defaultForm.tip;
          if (!this.form.abandonedCheckout.firstEmailScheduleTime)
            this.form.abandonedCheckout.firstEmailScheduleTime = this.defaultForm.abandonedCheckout.firstEmailScheduleTime;
          if (!this.form.abandonedCheckout.secondEmailScheduleTime)
            this.form.abandonedCheckout.secondEmailScheduleTime = this.defaultForm.abandonedCheckout.secondEmailScheduleTime;
          if (!this.form.abandonedCheckout.thirdEmailScheduleTime)
            this.form.abandonedCheckout.thirdEmailScheduleTime = this.defaultForm.abandonedCheckout.thirdEmailScheduleTime;

          if (!this.form.abandonedCheckout.firstSmsScheduleTime)
            this.form.abandonedCheckout.firstSmsScheduleTime = this.defaultForm.abandonedCheckout.firstSmsScheduleTime;
          if (!this.form.abandonedCheckout.secondSmsScheduleTime)
            this.form.abandonedCheckout.secondSmsScheduleTime = this.defaultForm.abandonedCheckout.secondSmsScheduleTime;
          if (!this.form.abandonedCheckout.thirdSmsScheduleTime)
            this.form.abandonedCheckout.thirdSmsScheduleTime = this.defaultForm.abandonedCheckout.thirdSmsScheduleTime;
        } else {
          this.form = Object.assign({}, this.defaultForm);
        }
        console.log('Theme useSimpleCheckout: ', this.form.useSimpleCheckout);
      } catch (error) {
        this.isLoading = false;
      }
      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
ul.list-theme {
  padding-left: 0;
  margin-top: 12px;
  list-style: none;
  gap: 16px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  @media screen and (min-width: 768px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  li {
    display: block;
    cursor: pointer;
    .image-wrapper {
      position: relative;
      border: solid 1px #e8e8e8;
      border-radius: 4px;
      overflow: hidden;
      height: 250px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fafafa;
      img {
        display: block;
        width: 100%;
        height: 100%;
        max-width: 400px;
        object-fit: contain;
      }
    }
    p {
      font-weight: 500;
      font-size: 16px;
      padding: 4px 0;
      margin: 0;
      color: #9e9e9e;
    }
    &.actived {
      .image-wrapper {
        background-color: var(--v-primary-base);
        border-color: var(--v-primary-base);
      }
      p {
        color: var(--v-primary-base);
      }
    }
  }
}
.image-preview {
  width: 100%;
  img {
    object-fit: contain;
    width: 100%;
  }
}
</style>
